import React, { Component } from 'react';
import { Row, Input, Col, DatePicker } from "antd";
import "./index.scss"
import moment from 'moment';
class Title extends Component {
    render() {
        const { taker, att1, att, office1, office, venue, date } = this.props.data;
        const onChange = this.props.onChange;
        return (
            <div className="metting-table1-title">
                <Row>
                    <Col span={6}>Date:Time</Col>
                    <Col span={18}>
                        <DatePicker
                            showTime 
                            value={date ? moment(date) : null}
                            onChange={(_, str) => onChange('date', str)}
                            locale={'zh-cn'}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col span={6}>Venue:</Col>
                    <Col span={18}>
                        <Input
                            type="text"
                            className="input"
                            value={venue}
                            onChange={(e) => {
                                onChange('venue', e.target.value)
                            }}
                        ></Input>
                    </Col>
                </Row>
                <Row>
                    <Col span={6}>Corporate Office Attendees:</Col>
                    <Col span={9}>
                        <Input
                            type="text"
                            className="input"
                            value={office}
                            onChange={(e) => {
                                onChange('office', e.target.value)
                            }}
                        ></Input>
                    </Col>
                    <Col span={9}>
                        <Input
                            type="text"
                            className="input"
                            value={office1}
                            onChange={(e) => {
                                onChange('office1', e.target.value)
                            }}
                        ></Input>
                    </Col>
                </Row>
                <Row>
                    <Col span={6}>Hotel Attendees:</Col>
                    <Col span={9}>
                        <Input
                            type="text"
                            className="input"
                            value={att}
                            onChange={(e) => {
                                onChange('att', e.target.value)
                            }}
                        ></Input>
                    </Col>
                    <Col span={9}>
                        <Input
                            type="text"
                            className="input"
                            value={att1}
                            onChange={(e) => {
                                onChange('att1', e.target.value)
                            }}
                        ></Input>
                    </Col>
                </Row>
                <Row>
                    <Col span={6}>Minutes Taker:</Col>
                    <Col span={18}>
                        <Input
                            type="text"
                            className="input"
                            value={taker}
                            onChange={(e) => {
                                onChange('taker', e.target.value)
                            }}
                        ></Input>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Title;


// WEBPACK FOOTER //
// ./src/components/table/other/meetingMinutes/Title.js